/**
 * 救援公司按月统计
 * 创建时间：2017-11-27
 * 创建人：baixx
 */
<template>
<div class="wrapper-content fadeInRight animated tabBox" id="cpmpany-statistics-list">
    <div class="row ibox-content" v-loading="loadingstatus" element-loading-text="加载中">	   	
		<!--表单查询开始-->
		<div class="form-horizontal pt10px">
			<div class="form-group">
				<label class="col-sm-1 control-label">救援公司</label>
				<div class="col-sm-3">
					<input type="text" class="form-control menuInputBrand" id="groupName_listsCompany" @focus="showMenuSelectName" readonly value="单击选择" style="background: #47ac89;color: #fff;border-width: 0;border-radius: 4px;">
					<div id="menuContentCompanyMonth" class="menuContent" style="display:none; position: absolute;">
						<ul id="orgTreeBrandCompanyMonth" class="ztree ztree-slide" style="margin-top:0; width:100%; height: 300px;"></ul>
					</div>
		        </div>
		        <label class="col-sm-1 control-label">统计开始时间</label>
		        <div class="col-sm-3 layui-inline" v-bind:class="{ 'form-group--error': !validDates }">
				    <input type="text" class="form-control" @focus="leftFocus" id= "startTimeCompanyId" v-model="startTimeStr" readonly  style="background: #FFFFFF;border:1px solid #ccc;">
				     <p v-show="!validDates" class="cus_message form-group__message">开始时间必须小于结束时间</p>
				     
				    <div v-show="startTime" class="layui-laydate">    
					    <div class="layui-laydate-main laydate-main-list-0" style="width:100%;">   
					       <div class="layui-laydate-header">
								<!--<i class="layui-icon laydate-icon laydate-prev-y"></i> -->
								<i @click="leftStartYear" class="layui-icon laydate-icon laydate-prev-m"></i>
								<div class="laydate-set-ym">
									<span lay-ym="2017-12" lay-type="year">{{monthStart}}年</span>
								</div>
								<i @click="rightStartYear" class="layui-icon laydate-icon laydate-next-m"></i>
								<!--<i class="layui-icon laydate-icon laydate-next-y"></i>-->
							</div>
					       <div class="layui-laydate-content">
								<ul class="layui-laydate-list laydate-month-list">
									 <li :id="index+'one'" @click="monthLeftClick(index)" v-for="(item,index) in monthArr">
										{{item}}
									</li>
								</ul>
							</div>
						</div>
				    </div> 
				</div>
				<label class="col-sm-1 control-label">统计结束时间</label>
				<div class="col-sm-3 layui-inline" v-bind:class="{ 'form-group--error': !validDates }">
					<input type="text" class="form-control" @focus="rightFocus" id= "endTimeCompanyId" v-model="endTimeStr" readonly  style="background: #FFFFFF;border:1px solid #ccc;">
				    <p v-show="!validDates" class="cus_message form-group__message">开始时间必须小于结束时间</p>
				    <div v-show="endTime" class="layui-laydate">    
					    <div class="layui-laydate-main laydate-main-list-0" style="width:100%;">   
					       <div class="layui-laydate-header">
								<!--<i class="layui-icon laydate-icon laydate-prev-y"></i> -->
								<i @click="leftEndYear" class="layui-icon laydate-icon laydate-prev-m"></i>
								<div class="laydate-set-ym">
									<span lay-ym="2017-12" lay-type="year">{{monthEnd}}年</span>
								</div>
								<i @click="rightEndYear" class="layui-icon laydate-icon laydate-next-m"></i>
								<!--<i class="layui-icon laydate-icon laydate-next-y"></i>-->
							</div>
					       <div class="layui-laydate-content">
								<ul class="layui-laydate-list laydate-month-list">
									 <li :id="index+'two'" @click="monthRightClick(index)" v-for="(item,index) in monthArr">
										{{item}}
									</li>
								</ul>
							</div>
						</div>
				    </div> 
	    
				</div>
			</div>
			<div class="form-group">
				<div class="col-sm-12 text-right">
					<button type="button" class="btn btn-primary" :disabled="!validDates" @click="searchInfo">开始统计</button>
					<button type="button" class="btn btn-primary"  @click="resetQueryParams">重置</button>
				</div>
			</div>
			<div class="hr-line-dashed"></div>
			<div class="form-group">
				<div class="col-sm-12 text-right">
					<button type="button" @click="exportCompanyStatistics" class="btn btn-primary">导出</button>
				</div>
			</div>
		</div>
		<!--表单查询结束-->
		<!--表格开始-->
		 <div style="width:100%;" v-show="nameArr.length>0">
            <div class="t_left">
                <div class="cl_freeze" id="cl_freeze">
                    <table class="table table-striped table-bordered">
	                    <thead>	
	                    	<tr>
								<th style="height:70px;">日期</th>
							</tr>
						</thead>	 
	                    <tbody>   
	                        <tr v-for="(fileInfo,index) in nameArr" v-bind:key="index">
								<td>{{fileInfo}}</td>
							</tr>
							<tr>
								<td>合计</td>
							</tr>
						</tbody>	
                    </table>
                </div>
            </div>
            <div class="t_r">
                <!--<div class="t_r_content" id="t_r_content" onscroll="aa()">-->
                <div class="t_r_content" id="t_r_content">
                    <table frame=hsides id="companyMonthStatistics" class="table table-striped table-bordered"> 
                    	<thead bgcolor="#F0F0F0">	
	                    	<tr>
								<th v-for="day in dateArr" class="text-center" colspan="3">{{day}}</th>
							</tr>
							<tr>
								<template v-for="day in dateArr">
									<th>好评率</th>
									<th>接单率</th>
									<th>上线率</th>
								</template> 
							</tr>
						</thead>	 
                        <tbody > 
                        	<tr v-for="drive in driverArr">
                        		<template v-for="info in drive">
                        			<td>{{info.positiveRate}}%</td>
									<td>{{info.orderRate}}%</td>
									<td>{{info.onlineRate}}%</td>
                        		</template> 
                        	</tr>
                        	<tr>
                        		<template v-for="info in totalsArr">
                        			<td>{{info.positiveRate}}%</td>
									<td>{{info.orderRate}}%</td>
									<td>{{info.onlineRate}}%</td>
                        		</template> 
                        	</tr>
						</tbody>	
                    </table>
                </div>
            </div>
            <div class="t_rightd">
                <div class="cl_freeze" id="cl_freeze">
                    <table class="table table-striped table-bordered">
                    	<thead>
	                    	<tr>
								<th class="text-center" colspan="3">合计</th>
							</tr>
							<tr>
								<th>好评率</th>
								<th>接单率</th>
								<th>上线率</th>
							</tr>
						</thead> 
                        <tbody>	
	                        <tr v-for="(fileInfo,index) in totalArr" v-bind:key="index">
								<td>{{fileInfo.positiveRate}}%</td>
								<td>{{fileInfo.orderRate}}%</td>
								<td>{{fileInfo.onlineRate}}%</td>
							</tr>
						</tbody>	
                    </table>
                </div>
            </div>
        </div>
         <!--统计开始时间-->
	   
	    <!--统计结束时间-->
	    
		<!--分页组件开始-->
		<pagination v-if="nameArr.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
		<!--分页组件结束-->
		<!--弹出框子组件-->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
	</div>
</div>	
</template>
<script>
	import Pagination from 'components/common/Pagination'
	import { zh } from 'flatpickr/dist/l10n/zh';
	import { OPERATE_EXCEPTION } from 'static/message'
	import TabModal from 'components/common/TabModal'
	import classlist from 'util/classlist'
	import 'assets/plugins/laydate/theme/default/laydate.css'

	export default {
		name: "PageCompanyMonthStatisticsList",
		components: {
			Pagination,
			TabModal,
		},
		data() {
			return {
				loadingstatus:false,
				monthStart:parseInt((new Date()).Format("yyyy")),
			    monthEnd:parseInt((new Date()).Format("yyyy")),
			    startTime:false,
			    endTime:false,
				leftDistance:null,
				rightDistance:null,
				monthArr:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],
				pageInfo:{},	                         //分页所需信息
				messageStr: "",					         // 弹出框内容
				scrollTop: '',
				startTimeStr: "",						 // 开始时间
				endTimeStr: "",						     // 结束时间
				queryParam:{			
					startTimeStr: "",				     // 开始时间
					endTimeStr: "",						 // 结束时间
					customerIds: "",		             // 救援公司id
					page_index: 1,                       // 页数
				}, 
			    nameArr:[],
			    driverArr:[], 
			    dateArr:[],
			    totalArr:[],                             //合计 1
			    totalsArr:[],                            //合计 2
			    companysArr:[],                          //救援公司
			    selectCompanysArr:[],                    //已选救援公司
			    isRequest:true,
			    settingName: {
					data: {
						simpleData: {
							enable: true,
							pIdKey: "parentId"
						}
					},
					check: {
		           		enable: true,
		           		chkboxType : { "Y" : "", "N" : "" }
		           	},
					view: {
						dblClickExpand: false,
						selectedMulti: true,
						autoCancelSelected: true
					},
					callback: {
						onCheck: this.onClickSelectName
					}
				},
			};
		},
		computed: {
			validDates: function(){
				if(this.startTimeStr.split("-")[0] && this.endTimeStr.split("-")[0] && this.startTimeStr.split("-")[0] <=this.endTimeStr.split("-")[0]){
					if(parseInt(this.startTimeStr.split("-")[1])>parseInt(this.endTimeStr.split("-")[1])){
						return false;
					}else{
						return true;
					}
				}
				if(this.startTimeStr.split("-")[0] && this.endTimeStr.split("-")[0] && this.startTimeStr.split("-")[0] > this.endTimeStr.split("-")[0]){
					return false;
				} else {
					return true;
				}
			}
		},
		beforeMount() {
			//获取救援公司
			this.getCompanys();
			//this.getTableInfo();
		},
		methods: {
			//选中月份触发
			monthLeftClick(index){
				var e = document.getElementById(index+'one')
				$(e).siblings().removeClass("layui-this")
				$(e).addClass("layui-this")
				this.startTimeStr = this.monthStart +"-"+(index+1)
				this.startTime = false;
			},	
			//选中月份触发
			monthRightClick(index){
				var e = document.getElementById(index+'two')
				$(e).siblings().removeClass("layui-this")
				$(e).addClass("layui-this")
				this.endTimeStr = this.monthEnd +"-"+(index+1)
				this.endTime = false;
			},	
			leftStartYear(){
				this.monthStart -=1 
			},
			rightStartYear(){
				this.monthStart +=1 
			},
			leftEndYear(){
				this.monthEnd -=1 
			},
			rightEndYear(){
				this.monthEnd +=1 
			},
			//左聚焦
			leftFocus(){
				this.startTime = true;
				this.endTime = false;
			},
			//右聚焦
			rightFocus(){
				this.endTime = true;
				this.startTime = false;
			},
			showMenuSelectName(){
				$("#menuContentCompanyMonth").slideDown("fast");
				$("body").bind("mousedown", this.onBodyDownsName);
			},
			onBodyDownsName(event){
				var self = this;
				if (!(event.target.id == "groupName_listsCompany" || event.target.id == "menuContentCompanyMonth" || $(event.target).parents("#menuContentCompanyMonth").length>0)) {
					this.hideMenusName();
				}
			},
			hideMenusName() {
				$("#menuContentCompanyMonth").fadeOut("fast");
				$("body").unbind("mousedown", this.onBodyDownsName);
			},
			treeInitSelectName(){//初始化z-tree树
				$.fn.zTree.init($("#orgTreeBrandCompanyMonth"), this.settingName, this.companysArr);
			},
			onClickSelectName(event,treeId,treeNode){//点击树节点
				if (treeNode.checked){
					this.selectCompanysArr.push(treeNode.id);
				}else{
					let index = this.selectCompanysArr.findIndex(function(value, index, arr) {
					   return value == treeNode.id;
					});
					if (index != -1){
						this.selectCompanysArr.splice(index,1);
					}
				}
			},
			//获得救援公司名称
			getCompanys(){
				if(this.isRequest == true){
					this.loadingstatus = true; 
				}
				//this.$http.get('../../static/companys.json')
				this.$http.get(process.env.API_INSURANCE_ROOT  + '/rescue-api/account/customer/fleet')
					.then( res => {
						if(res.body.success){
							this.companysArr = res.body.data;
							this.companysArr.map(item=>{
								item.name=item.groupName;
						    })
							this.treeInitSelectName();
							//设置默认为全选中状态
							var treeObj = $.fn.zTree.getZTreeObj("orgTreeBrandCompanyMonth");
							var node = treeObj.getNodes();
			    			var nodes = treeObj.transformToArray(node);
							nodes.forEach( item => {
								item.checked = true;
								this.selectCompanysArr.push(item.id);
							})
							treeObj.refresh();
							if(this.isRequest == true){
								this.getTableInfo();
							}
						} else {
							this.loadingstatus = false;
							this.openModalMsg(res.body.message);
						}
					}, res => {
						this.openModalMsg(res.body.message);
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
				})
			},
			//查询方法
			searchInfo(){
				this.queryParam.startTimeStr = this.startTimeStr.replace(/[&\|\\\/\s+:*^%$#@\-]/g,"")	
				this.queryParam.endTimeStr = this.endTimeStr.replace(/[&\|\\\/\s+:*^%$#@\-]/g,"")
				this.queryParam.page_index = 1;
				this.getTableInfo();
			},
			// 获取列表信息
			getTableInfo() { 
				if(this.selectCompanysArr.length ==0){
					this.openModalMsg("救援公司不能为空");
					return;
				}
				this.queryParam.customerIds = this.selectCompanysArr.join(',');
				this.loadingstatus = true; 
				//this.$http.get('../../static/driveStatisticsList.json')
				this.$http.get(process.env.API_INSURANCE_ROOT  + '/rescue-api/report/statistics/customer/count/month', {params: this.queryParam})
					.then( res => { 
						if(res.data.success){
							const resInfo = res.body.data;	
							if(res.body.data.totalRow.length == 0){
								this.loadingstatus = false; 
								this.openModalMsg("所选查询条件暂无统计结果！");
								this.nameArr = [];
								//this.dateArr = [];
								return;
							}
							this.nameArr = [];
							this.driverArr = [];
							for(var key in res.body.data.customers){
							    this.nameArr.push(key) 
							    this.driverArr.push(res.body.data.customers[key])
							} 
							this.dateArr = [];
							this.driverArr[0].map(item=>{
								this.dateArr.push(item.customerName) 
							})  
							//合计1
							this.totalArr = res.body.data.totalRow;
							//合计2
							this.totalsArr = res.body.data.totalColumn;
							var ddd=document.getElementById("companyMonthStatistics"); 
							if(this.dateArr.length>0 &&this.dateArr.length<5){
								ddd.style.cssText='min-width: 1000px;'; 
							}
							if(this.dateArr.length>=5 && this.dateArr.length<10){
								ddd.style.cssText='min-width: 2200px;'; 
							}
							if(this.dateArr.length>=10 && this.dateArr.length<15){
								ddd.style.cssText='min-width: 4200px;'; 
							}
							if(this.dateArr.length>=15){
								ddd.style.cssText='min-width: 6500px;'; 
							}
							const {pageNum,pages,totals,isFirstPage,isLastPage} = resInfo;
							this.pageInfo = {
								pageNum: pageNum,
								pages: pages,
								total: totals,
								isFirstPage: isFirstPage,
								isLastPage: isLastPage
							}
						} else {
							this.openModalMsg(res.body.message);
						}
						this.loadingstatus = false;
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus = false;
				})
			},
			//导出
			exportCompanyStatistics(){                           
				this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/report/statistics/customer/export/month',{params: this.queryParam})
					.then((res)=>{
					if(res.body.success){
						let str = res.body.data;
					//	var path = "http://192.168.1.53:8888/api";
						var path = process.env.EXPORT_PATH;
					    var api = process.env.API_ROOT;
						var fileName = path + api + '/noauth/export?url=' + str + '&path=' + this.$store.state.user.userId;
		    			var elemIF = document.createElement("iframe");   
				      	elemIF.src = fileName;   
				        elemIF.style.display = "none";   
				        document.body.appendChild(elemIF); 
					}else{
						this.openModalMsg(res.body.message);
					}
					this.loadingstatus = false;
				}, res => {
					this.loadingstatus = false;
					this.openModalMsg(res.body.message);
				}).catch( res => {
					this.loadingstatus = false;
					this.openModalMsg("请求异常");
				})	
			},
			//从分页组件获取页码参数
			getPageNo(param) {
				this.queryParam.page_index = param;
				this.getTableInfo();
			},
			//重置信息
			resetQueryParams:function(){
				this.startTimeStr = "",
				this.endTimeStr = "",
				this.isRequest = false;
				this.getCompanys();
				this.queryParam = {			
					startTimeStr: "",				     // 开始时间
					endTimeStr: "",						 // 结束时间
					customerIds: "",		             // 救援公司id
					page_index: 1,                       // 页数
				}
			},
			// 消息弹出框相关 
			openModal(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#cpmpany-statistics-list',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#cpmpany-statistics-list',this);
        	},
        	closeModalMsg(){
        		this.closeModal("modalMsg");
        	},
        	openModalMsg(message){
        		this.messageStr = message;
        		this.openModal("modalMsg")
        	}
		}
	}
</script>
<style scoped>
    table {
        border-collapse: collapse;
        border-spacing: 0px;
        width: 100%;
        border-top: #DCDCDC solid 1px;
    }
    
    .t_left {
        width: 10%;
        height: auto;
        float: left;
      /*  border-top: 1px solid #000;
        border-left: 1px solid #000;*/
    }
    .t_rightd {
        width: 20%;
        height: auto;
        float: left;
       /* border-top: 1px solid #000;
        border-left: 1px solid #000;*/
    }
    /*t_r_content和cl_freeze高度相差20px， 高度为外观显示高度，可根据情况调整*/
    
    .t_r_content {
        width: 100%;
        height: 100%;
        background: #fff;
        overflow: auto;
    }
    .cl_freeze {
        height: 100%;
        overflow: hidden;
        width: 100%;
    }
    /* width 调整左边标题列宽度（左侧外观显示宽度）; 指定为width:auto 在Opera下显示有问题; height比 t_r_content 高度小20px*/
    /* width 宽度为 右侧外观显示宽度 实际显示宽度大小为“t_r”宽度加上“cl_freeze”宽度 */
    /* 如果显示不正常，调整 t_r的width 使其和t_left的width之和小于100%；等于100%时会有问题*/
    
    .t_r {
        width: 70%;
        height: auto;
        float: left;
      /*  border-top: 1px solid #000;
        border-right: #000 solid 1px;*/
    }
    
    .t_r table {
        width: 100%;
        min-width: 1000px;
    }
    
    .t_r_title {
        width: 1720px;
    }
    /*宽度比 t_r table 大20px （至少大20，小了滚动条滑到右侧显示有问题）*/
    
    .t_r_t {
        width: 100%;
        overflow: hidden;
    }
    
    .bordertop {
        border-top: 0px;
    }
    .menuInputBrand{
		position:relative;
	}
	.menuContent{
		position:absolute;
		top:31px;
		left:6px;
		border:1px solid #ddd;
		z-index:999;
		width:calc(100% - 10px);
	}
	.layui-laydate-main{
		/*width:290px;*/
		width:calc(100% - 10px);
	}
</style>


// WEBPACK FOOTER //
// PageCompanyMonthStatisticsList.vue?23dc5cae